import { createAction } from '@reduxjs/toolkit'

import type { TSavedDashboardFilterDto } from '@homepal/api-contract'

// tryGetAllSavedDashboardFilters
export const getAll = createAction('get_saved_dashboard_filters')
export const getAllSuccess = createAction<TSavedDashboardFilterDto[]>(
  'get_saved_dashboard_filters_success'
)
export const getAllFailed = createAction('get_saved_dashboard_filters_failed')

// tryCreateSavedDashboardFilter
export const create = createAction('create_saved_dashboard_filter')
export const createSuccess = createAction<TSavedDashboardFilterDto>(
  'create_saved_dashboard_filter_success'
)
export const createFailed = createAction('create_saved_dashboard_filter_failed')

// tryUpdateSavedDashboardFilter
export const update = createAction('update_saved_dashboard_filter')
export const updateSuccess = createAction<TSavedDashboardFilterDto>(
  'update_saved_dashboard_filter_success'
)
export const updateFailed = createAction('update_saved_dashboard_filter_failed')

// tryDeleteSavedDashboardFilter
export const destroy = createAction('delete_saved_dashboard_filter')
export const destroySuccess = createAction<string>(
  'delete_saved_dashboard_filter_success'
)
export const destroyFailed = createAction(
  'delete_saved_dashboard_filter_failed'
)
